













import { Component, Prop, Vue } from 'vue-property-decorator';
import { CartModel } from '@/models/CartModel';

@Component
export default class CartOrderFooter extends Vue {
  @Prop() private cart!: CartModel;
}
